export default __webpack_public_path__ + "static/media/Group 11812.a657c88a.svg";